export default function TimeRegistryLogo({ height = 70 }) {
  // Calculate offsets for layered effect - more pronounced
  const layers = [
    { offset: 0, opacity: 1.0 },      // Top layer - fully opaque
    { offset: 4, opacity: 0.5 },     // Second layer
    { offset: 8, opacity: 0.3 },     // Third layer
    { offset: 12, opacity: 0.15 },     // Fourth layer
    { offset: 16, opacity: 0.08 },   // Fifth layer
    { offset: 20, opacity: 0.04 },   // Bottom layer - most faded
  ];

  return (
    <svg
      height={height}
      viewBox="0 0 280 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      {/* Fading layers effect - multiple text layers with decreasing opacity */}
      {layers.map((layer, index) => (
        <g key={index}>
          {/* TIME - stacked on top */}
          <text
            x={layer.offset}
            y={32 + layer.offset}
            fontSize="32"
            fontFamily="'Courier New', monospace"
            fontWeight="900"
            fill="#000000"
            letterSpacing="5"
            opacity={layer.opacity}
          >
            TIME
          </text>
          {/* REGISTRY - stacked below */}
          <text
            x={layer.offset}
            y={62 + layer.offset}
            fontSize="32"
            fontFamily="'Courier New', monospace"
            fontWeight="900"
            fill="#000000"
            letterSpacing="5"
            opacity={layer.opacity}
          >
            REGISTRY
          </text>
        </g>
      ))}
    </svg>
  );
}
